// "Mark as Lost" reasons (CRM-2026 Phase 4) — a GENUINE lead/appraisal we lost,
// kept distinct from Ignore (garbage) so lead-quality data stays honest. Shared
// by the Seller Leads holding area and the pipeline card / Edit Appraisal modal
// so the reason list is identical everywhere (Monday 13068564317). These values
// mirror the backend Lead.LOST_REASON_CHOICES exactly.
export const LOST_OTHER = "other";

export const LOST_REASONS = [
  { value: "chose_other_agent", label: "Chose another agent" },
  { value: "sold_by_another_agent", label: "Sold by another agent" },
  { value: "already_listed", label: "Already listed elsewhere" },
  { value: "decided_not_to_sell", label: "Decided not to sell" },
  { value: "uncontactable", label: "Uncontactable after attempts" },
  { value: "no_response", label: "No response" },
  { value: "vendor_postponed", label: "Vendor postponed" },
  { value: "other", label: "Other" },
];

// Human labels for a Property's withdrawn_reason, for the pipeline Lost column.
// Covers the "genuine loss" reasons that qualify for that column: the Lost
// button (lead_lost) and the two manual appraisal-withdrawal reasons.
const WITHDRAWN_REASON_LABELS = {
  lead_lost: "Marked lost",
  lost_to_other_agent: "Lost to another agent",
  owner_not_proceeding: "Owner not proceeding",
  // A sales listing lost off the Prospects board (LISTING_LOST_REASONS below).
  listed_with_another_agent: "Listed with another agent",
  sold_by_another_agent: "Sold by another agent",
  owner_withdrew: "Owner withdrew",
  agreement_expired: "Agreement expired",
  other: "Other",
};

// "Move to Lost" on a Listed or For Sale card in Prospects (Christian Gravias,
// Monday 12988442847, 13 Oct 2026). A listing that is lost is WITHDRAWN, so
// these are the listing withdraw reasons the backend accepts
// (Property.WITHDRAWN_REASON_LISTING_CHOICES), less the ones that are not a
// lost sale (Duplicate, Error, Leased by another agent). They mirror
// Property.LOST_LISTING_REASONS, which the Prospects LOST column reads.
export const LISTING_LOST_REASONS = [
  { value: "listed_with_another_agent", label: "Listed with another agent" },
  { value: "sold_by_another_agent", label: "Sold by another agent" },
  { value: "owner_withdrew", label: "Owner withdrew" },
  { value: "agreement_expired", label: "Agreement expired" },
  { value: "other", label: "Other" },
];

// "Other" reads as the agent's own words on the Lost card ("Other: Selling
// privately"), the reason Monday 13375284987 asked for.
export function withNote(label, note) {
  const text = (note || "").trim();
  return text ? `${label}: ${text}` : label;
}

export function withdrawnReasonLabel(code) {
  if (!code) return "Lost";
  return WITHDRAWN_REASON_LABELS[code] || "Lost";
}
